import { render, staticRenderFns } from "./caseList.vue?vue&type=template&id=5216e3d1&scoped=true"
import script from "./caseList.vue?vue&type=script&lang=js"
export * from "./caseList.vue?vue&type=script&lang=js"
import style0 from "./caseList.vue?vue&type=style&index=0&id=5216e3d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5216e3d1",
  null
  
)

export default component.exports